'use client';

import type { FC, ReactNode } from 'react';
import { useLayoutEffect } from 'react';
import { useScreenLayout } from './useScreenLayout';

interface ScreenFixedTopProps {
  title?: string;
  children?: ReactNode;
  className?: string;
}

export const ScreenFixedTop: FC<ScreenFixedTopProps> = ({ title, children, className }) => {
  const { setFixedTop, clearFixedTop } = useScreenLayout();

  useLayoutEffect(() => {
    setFixedTop(children, title, className);
  }, [children, title, className, setFixedTop]);

  useLayoutEffect(() => () => clearFixedTop(), [clearFixedTop]);

  return null;
};
